import { AddressModel } from '@steelbuy/ts-shared';

import { HistoricalAddressEntityData } from './HistoricalAddressEntityData';
import { useEntityData } from '../../util/consumer/EntityConsumerHook';

export const useHistoricalAddressEntityData = () => useEntityData<AddressModel>(HistoricalAddressEntityData);
